






















import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import FeaturesTable from "@/components/tables/features-table.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import TabsSettings from "@/components/tabs/settings.vue";

@Component({
    name: "features",
    components: { TabsSettings, PageHeader, Page, FeaturesTable },
})
export default class Features extends Vue {}
